import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import logo from 'resources/Fedex-logo.png';
import { colors } from 's1-ui';
import CarrierAccounts from '../CarrierAccounts/CarrierAccounts';
import CarrierAccountsForm from '../CarrierAccounts/CarrierAccountsForm';
import { pageWidth } from '../../../constants';

const { blueMedium, grayLight, redDark } = colors;

const styles = {
  hero: {
    minHeight: '150px',
    backgroundColor: grayLight,
    display: 'flex',
    alignItems: 'center',
    maxWidth: pageWidth,
    width: 'calc(100% - 48px)',
    margin: 'auto'
  },
  accountInfo: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '50%',
    paddingRight: 40,
    borderRight: '1px solid lightgray',
  },
  accountName: {
    fontSize: '36px',
    fontWeight: 200,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingBottom: '20px'
  },
  fbpn: {
    fontSize: '20px',
    color: 'gray',
    fontWeight: 300
  },
  base: {
    width: '100%',
    backgroundColor: grayLight,
  },
  carrierGroup: {
    paddingLeft: '50px',
    marginTop: '20px',
    marginBottom: '10px'
  },
  noAccounts: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column'
  },
  logo: {
    height: '35px',
    paddingBottom: 15
  },
  addAccount: {
    textTransform: 'none',
    padding: '0px',
    color: redDark,
    marginTop: 15
  },
  addAnotherAccount: {
    textTransform: 'none',
    padding: '8px 0px',
    color: blueMedium
  }
};

export const UnstyledHeroBannerDisplay = ({
  classes, carrierAccount, addAccount, toggleAddAccount, history, newLicenseNumber, newLicenseChange, cancelAdd, handleNewAccountSubmit, errors
}) => (
  <div className={ `CCP__HeroBanner__base ${classes.base}` }>
    <div className={ classes.hero }>
      <div className={ classes.accountInfo }>
        <span className={ `CCP__HeroBanner__account-name ${classes.accountName}` }>{ carrierAccount && (carrierAccount.TradeName || carrierAccount.LegalName) }</span>
        <span className={ `CCP__HeroBanner__fbpn ${classes.fbpn}` }>{ carrierAccount && carrierAccount.FBPN }</span>
      </div>
      <div className={ classes.carrierGroup }>
        { carrierAccount && carrierAccount.CarrierAccounts && carrierAccount.CarrierAccounts.length !== 0
          && (
            <CarrierAccounts
              data={ carrierAccount && carrierAccount.CarrierAccounts }
              addAccount={ addAccount }
              toggleAddAccount={ toggleAddAccount }
            />
          )
        }
        <div>
          { carrierAccount && carrierAccount.CarrierAccounts && carrierAccount.CarrierAccounts.length !== 0
            ? (
              <div>
                { carrierAccount.CarrierAccounts.length < 4
                  ? (
                    <div>
                      { !addAccount
                        ? (
                          <Button
                            className="CCP__HeroBanner__AddAccountButton"
                            classes={ { root: classes.addAnotherAccount } }
                            onClick={ () => toggleAddAccount() }
                          >
                            + Add another account
                          </Button>
                        )
                        : (
                          <CarrierAccountsForm
                            newLicenseNumber={ newLicenseNumber }
                            onChange={ newLicenseChange }
                            cancel={ cancelAdd }
                            onSubmit={ handleNewAccountSubmit }
                          />
                        )
                      }
                    </div>
                  )
                  : (
                    <Button
                      classes={ { root: classes.addAnotherAccount } }
                      onClick={ () => history.push('/settings') }
                    >
                      + { carrierAccount.CarrierAccounts.length - 3 } more in Account Settings
                    </Button>
                  )
                }
              </div>
            )
            : (
              <div className={ `CCP__CarrierAccounts__no-accounts ${classes.noAccounts}` }>
                <img className={ classes.logo } src={ logo } alt="FedEx logo" />
                { !addAccount
                  ? (
                    <Button
                      classes={ { root: classes.addAccount } }
                      onClick={ () => toggleAddAccount() }
                    >
                      Add account number(s)
                    </Button>
                  )
                  : (
                    <div>
                      <CarrierAccountsForm
                        newLicenseNumber={ newLicenseNumber }
                        onChange={ newLicenseChange }
                        cancel={ cancelAdd }
                        onSubmit={ handleNewAccountSubmit }
                      />
                    </div>
                  )
                }
              </div>
            )
          }
          { errors && errors.newLicenseNumberError !== undefined && <div style={ { color: 'red', marginTop: 10 } }>{errors.newLicenseNumberError}</div>}
        </div>
      </div>
    </div>
  </div>
);


UnstyledHeroBannerDisplay.propTypes = {
  classes: PropTypes.object.isRequired,
  carrierAccount: PropTypes.object,
  addAccount: PropTypes.bool.isRequired,
  toggleAddAccount: PropTypes.func.isRequired,
  history: PropTypes.object,
  newLicenseNumber: PropTypes.string.isRequired,
  newLicenseChange: PropTypes.func.isRequired,
  cancelAdd: PropTypes.func.isRequired,
  handleNewAccountSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

UnstyledHeroBannerDisplay.defaultProps = {
  carrierAccount: undefined,
  history: undefined
};

export default withStyles(styles)(UnstyledHeroBannerDisplay);
